import { TypingMode, useProgressiveText } from "@/hooks/use-progressive-text";
import { Markdown } from "@/components/ai/chat/Markdown";
import { useEffect, useState } from "react";

const MESSAGE = "Waiting for environment to start";

export const ConversationMessageLoading = () => {
    const [message, setMessage] = useState("");
    const { text } = useProgressiveText(message, { speed: 10, mode: TypingMode.Character });

    useEffect(() => {
        const timeout = setTimeout(() => setMessage(MESSAGE), 1500);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <div data-testid="conversation-message-loading" data-completed={false} className="text-base">
            <Markdown content={text} />
        </div>
    );
};
